import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CustomFieldDefinition } from 'types/customField';
import request from 'utils/request';
import { SEQUENCES_CUSTOM_FIELDS_KEY } from './useSequenceCustomFieldDefinitions';

function updateSequenceCustomField(customField: CustomFieldDefinition) {
  return request(`/sequences-custom-fields/${customField.id}`, {
    method: 'PATCH',
    body: customField,
  });
}

export const useUpdateSequenceCustomFieldDefinition = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateSequenceCustomField,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SEQUENCES_CUSTOM_FIELDS_KEY],
      });
    },
  });
};
